import { toast } from 'react-toastify';
import { ErrorToastAlert, InfoToastAlert, SuccessToastAlert, WarningToastAlert } from '../components/core/ToastAlerts';
import { TOAST_TYPES } from '../constants/settings.constants';

const showToast = (type = TOAST_TYPES.INFO, message = '') => {
  switch (type) {
    case TOAST_TYPES.INFO:
      return toast(<InfoToastAlert message={message} />);
    case TOAST_TYPES.ERROR:
      return toast(<ErrorToastAlert message={message} />);
    case TOAST_TYPES.SUCCESS:
      return toast(<SuccessToastAlert message={message} />);
    case TOAST_TYPES.WARNING:
      return toast(<WarningToastAlert message={message} />);

    default:
      break;
  }
};

const toastService = { showToast };

export default toastService;
